

































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import { IOrderDto } from "../../types/interface/IOrderDto";
import { OrderDto } from "@/types/impl/OrderDto";
import {
  getOrderDetail,
  getOrderTimeRecord,
  getUserRatingForOrder,
  merchCancelOrder,
  refundOrderForCustomer
} from "../../api/net/order";
import OrderDetailHeader, { IStepItem } from "./components/step.vue";
import OrderTimeRecord, {
  IOrderInformation
} from "./components/order-information.vue";
import OrderOther from "./components/other.vue";
import {
  OrderStatus,
  DeliveryType,
  PaymentMethod,
  PaymentType,
  PaymentStatus
} from "../../types/enum/OrderEnum";
import OrderItemRow from "./components/order-item-row.vue";
import OrderUserRating from "./components/order-user-rating.vue";
import CustomerInformation from "./components/customer-information.vue";
import Header from "@/components/header.vue";
import { toLocalTime } from "../../api/net/util";

import ReasonBottomSheets from "../orders/components/bottom-sheets.vue";
import { IOrderItemDto } from "../../types/interface/IOrderItem";
import { pullOrderDefaultUrl } from "@/store/actions.ts";
import store from "../../store/index";
import { getOrderStatusForRequestOrderList } from "../../libs/utils";

interface ITimeStepItem {
  id: string;
  orderId: string;
  orderStatus: number;
  auditTime: string | Date;
  description: string;
}
@Component({
  components: {
    Header,
    OrderDetailHeader,
    OrderTimeRecord,
    OrderItemRow,
    OrderOther,
    OrderUserRating,
    ReasonBottomSheets,
    CustomerInformation
  }
})
export default class OrderDetail extends Vue {
  @Getter("headerTitle") headerTitle!: string;

  orderRating = -1;

  axiosFlag = false;

  order: IOrderDto = OrderDto;

  orderItems: IOrderItemDto[] = [];

  stepItems: IStepItem[] = [
    {
      text: "Submited",
      icon: "mdi-clipboard-list-outline",
      active: OrderStatus.WaitingForAcceptance
    },
    {
      text: "Paid",
      icon: "mdi-credit-card-outline",
      active: OrderStatus.WaitingForAcceptance
    },
    {
      text: "Accepted",
      icon: "mdi-clipboard-check-outline",
      active: OrderStatus.Processing
    },
    {
      text: "Pickup",
      icon: "mdi-package-variant",
      active: OrderStatus.Ready
    },
    {
      text: "Completed",
      icon: "mdi-check",
      active: OrderStatus.Completed
    }
  ];

  timeStepRecord: IOrderInformation = {};

  orderContentHeight: number = 1024;

  public get renderInformations(): IOrderInformation {
    return {
      "Payment Status":
        this.order.paymentStatus === PaymentStatus.Pending
          ? "Not Paid"
          : "Paid",
      "Order number": this.order.serialNumber || `0`,
      "Total Amount": `$ ${this.order.orderTotalReceivedByMerchant}`,
      "Order time": toLocalTime(this.order.orderDate || new Date())
    };
  }

  formatTime(date: string | Date) {
    return toLocalTime(date);
  }

  public get steps(): Array<IStepItem> {
    if (this.order.deliveryType === DeliveryType.Delivery) {
      this.stepItems.splice(3, 1, {
        text: "Delivery",
        icon: "mdi-truck-delivery",
        active: OrderStatus.Ready
      });
    }
    if (this.order.paymentType === PaymentType.Offline) {
      this.stepItems.splice(1, 1);
    }
    return this.stepItems;
  }

  public get showSpecialInstruction(): boolean {
    if (this.order.merch.acceptSpecialInstruction && this.order.remark)
      return true;
    return false;
  }

  showLoadingOrderFlag = false;
  showLoadingStepFlag = false;
  showLoadingRatingFlag = false;

  showLoadingFlag() {
    if (
      this.showLoadingOrderFlag &&
      this.showLoadingStepFlag &&
      this.showLoadingRatingFlag
    ) {
      store.commit("handleShowLoading", false);
      this.showLoadingOrderFlag = false;
      this.showLoadingStepFlag = false;
      this.showLoadingRatingFlag = false;
    }
  }

  async getOrder(orderId: string) {
    let { status, data } = await getOrderDetail(this.order.merchId, orderId);
    // store.commit("handleShowLoading", false);
    this.showLoadingOrderFlag = true;
    this.showLoadingFlag();

    if (status === 200) {
      this.order = data;
      this.orderItems = this.order.orderItems.filter((x: IOrderItemDto) => {
        if (x.subType === 0 && x.itemType === 0) {
          return x;
        }
      });
    }
  }

  async getOrderTimeStepRecord(orderId: string) {
    let {
      status,
      data: { result }
    } = await getOrderTimeRecord(this.order.merchId, orderId);
    // store.commit("handleShowLoading", false);
    this.showLoadingStepFlag = true;
    this.showLoadingFlag();
    if (status === 200) {
      try {
        this.timeStepRecord = result.reduce(
          (information: IOrderInformation, x: ITimeStepItem) => {
            information[x.description] = this.formatTime(x.auditTime);
            return information;
          },
          {}
        );
      } catch (error) {
        this.timeStepRecord = {};
      }
    } else {
      this.$message.show({
        text: `Network error`
      });
    }
  }

  async getUserRatingForOrder(orderId: string) {
    let userRatingDto;
    try {
      userRatingDto = await getUserRatingForOrder(this.order.merchId, orderId);
      // store.commit("handleShowLoading", false);
      this.showLoadingRatingFlag = true;
      this.showLoadingFlag();
    } catch (error) {}
    if (userRatingDto) {
      this.orderRating - userRatingDto.rating;
    }
  }
  backFnc() {
    let { orderId } = this.$route.query;
    let { from } = this.$route.query;
    if (from === pullOrderDefaultUrl.historyUrl) {
      return this.$router.replace({
        name: "History",
        query: {
          orderId: orderId
        }
      });
    }

    if (from === "Conversation") {
      return this.$router.go(-1);
    }

    this.$store.commit("handleClearOrderList");
    this.$store.commit("handleIsInPreOrderTab", false);
    this.$store.commit("handlePreOrderDate", "");
    if (!this.$store.state.isPc) {
      if (this.$store.state.keyword) {
        this.$store.dispatch("handleOrderList", {
          page: this.$store.state.currentOrderPage,
          keyword: this.$store.state.keyword,
          orderStatus: getOrderStatusForRequestOrderList("Processing"),
          ExcludePreOrderStatuses: []
        });
      } else {
        this.$store.dispatch("handleOrderList", {
          page: this.$store.state.currentOrderPage,
          keyword: this.$store.state.keyword,
          orderStatus: getOrderStatusForRequestOrderList("Processing"),
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering
          ]
        });
      }

      this.actionHandleRefundOrderList(this.$store.state.merchId);
    }

    this.$router.go(-1);
  }
  showReson: boolean = false;
  openModal() {
    this.showReson = true;
  }

  @Action("handleOrderList")
  private actionHandleOrderList!: () => Promise<any>;

  @Action("handleRefundOrderList")
  private actionHandleRefundOrderList!: (merchId: string) => Promise<any>;

  refreshOrderList() {
    this.actionHandleRefundOrderList(this.order.merchId);
    this.actionHandleOrderList();
  }
  async reasonSubmit(data: {
    reason: string;
    refund: number;
    selectItems: Array<string>;
  }) {
    let { reason, selectItems, refund } = data;

    let { status } = await refundOrderForCustomer(
      this.order.merchId,
      this.order.id,
      reason,
      refund,
      selectItems
    );
    if (status === 200) {
      this.refreshOrderList();
      this.$router.back();
    } else {
      this.$message.show({
        text: `Can't found order`
      });
    }
    store.commit("handleShowLoading", false);

    this.$message.show({
      text: "The order is refunded."
    });
  }

  public get isShowCustomerInformation(): boolean {
    return (
      this.order.deliveryType === DeliveryType.Delivery ||
      (this.order.deliveryType === DeliveryType.Pickup &&
        !!this.order.orderParkingLotPickupFieldValues.length)
    );
  }

  async mounted() {
    try {
      this.axiosFlag = false;
      let { orderId } = this.$route.query;
      if (!orderId) {
        this.$message.show({
          text: "OrderId can not be empty"
        });
        return;
      }
      await this.getUserRatingForOrder(String(orderId));
      await this.getOrderTimeStepRecord(String(orderId));
      await this.getOrder(String(orderId));
      this.orderContentHeight = document.body.offsetHeight - 145;
      this.axiosFlag = true;
    } catch (error) {}
  }
}
